function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" width="35" height="35" {...props}><path d="M27.19 14.362L13.641.813C13.189.271 12.467 0 11.744 0h-9.03C1.178 0 .004 1.174.004 2.71v9.03c0 .723.271 1.445.813 1.897l13.549 13.549c.542.542 1.265.813 1.897.813.632 0 1.355-.271 1.897-.813l9.03-9.03c1.084-.994 1.084-2.799 0-3.794M6.325 8.13a1.812 1.812 0 0 1-1.807-1.807c0-.994.813-1.807 1.807-1.807s1.807.813 1.807 1.807S7.319 8.13 6.325 8.13" fill="#4186e0" fillRule="nonzero" /></svg>;
});